import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useAppStore = defineStore('app', () => {
  const maintenance = ref(false);
  return { maintenance };
});
